import * as React from 'react';

export const WarningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
    {/* tslint:disable-next-line:max-line-length */}
    <path
      fill="#FF5050"
      fillRule="evenodd"
      d="M12.96 12.98H.959c-.737 0-1.198-.805-.83-1.448L6.13 1.05a.954.954 0 0 1 1.659 0l6 10.48c.369.644-.092 1.449-.829 1.449zM8 11.03c0-.579-.465-1.05-1.04-1.05s-1.042.471-1.042 1.05c0 .581.467 1.05 1.041 1.05.576 0 1.042-.469 1.042-1.05zM6.96 4.49c-.575 0-1.042.47-1.042 1.05 0 .58.314 4.172.89 4.172h.303c.576 0 .89-3.592.89-4.172 0-.58-.467-1.05-1.042-1.05z"
    />
  </svg>
);
